import { useEffect, useMemo } from 'react'

import type { PackagingDraftItem } from '@/lib/packaging-draft'
import {
    buildAvailableByMaterial,
    patchManualAvailable,
} from '@/lib/packaging-draft'
import { usePackagingLots } from '@/hooks/use-packaging-lot-query'

interface Args {
    value: PackagingDraftItem[]
    onChange: (items: PackagingDraftItem[]) => void
}

/**
 * Bổ sung số tồn cho các dòng vật tư NGƯỜI DÙNG TỰ THÊM vào đơn.
 *
 * Đơn hàng (và máy POS) KHÔNG còn tự sinh vật tư theo định mức nữa (#M-16):
 * việc đó chuyển sang màn tạo phiếu nhập kho hàng bán, nơi vật tư thật sự bị
 * trừ khỏi kho và người lập phiếu nhìn thấy lô nào bị trừ. Vật tư nhân viên tự
 * thêm vào đơn thì vẫn tính như cũ — chỉ bỏ phần TỰ ĐỘNG điền.
 *
 * Trả về bảng tồn theo material_id để caller hiển thị "Tồn" trên dòng.
 */
export function useOrderPackagingSync({ value, onChange }: Args) {
    // Bảng tồn theo material_id (cộng dồn quantity_available của các lô)
    // → dùng cho row 'manual' (sale thêm tay) để hiển thị tồn thật thay vì 0.
    const { data: lotsData } = usePackagingLots({ per_page: 500 })
    const availableByMaterial = useMemo(
        () => buildAvailableByMaterial(lotsData?.data),
        [lotsData],
    )

    // Khi `usePackagingLots` query trả dữ liệu sau lúc user đã thêm tay
    // (mat picker đã hoạt động trước khi lots load xong), patch lại
    // `available` cho row 'manual' để hiển thị tồn thật thay vì 0.
    useEffect(() => {
        const patched = patchManualAvailable(value, availableByMaterial)
        if (patched) onChange(patched)
    }, [availableByMaterial, value, onChange])

    return { availableByMaterial }
}
